import React, { useState } from 'react';
import pdfFile from '../assets/Registration & TItle for Ph.D..pdf';
import 'bootstrap/dist/css/bootstrap.min.css';

const sections = [
    { id: 'registered-scholars', name: 'पञ्जीकृत शोध छात्र सूची' }
];

export default function RegisteredResearchScholars() {
    const [activeTab, setActiveTab] = useState('registered-scholars');
    const [showSidebar, setShowSidebar] = useState(true);

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle button for mobile */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside className={`p-3 shadow d-flex flex-column bg-white ${showSidebar ? 'd-block' : 'd-none d-md-flex'} col-md-3`}>
                <h5 className="text-center fw-bold mb-3">पञ्जीकृत शोध छात्र सूची</h5>
                {sections.map(section => (
                    <p
                        key={section.id}
                        onClick={() => {
                            setActiveTab(section.id);
                            setShowSidebar(false);
                        }}
                        style={{
                            cursor: 'pointer',
                            padding: '10px',
                            borderRadius: '8px',
                            fontWeight: activeTab === section.id ? 'bold' : 'normal',
                            backgroundColor: activeTab === section.id ? '#77236b' : '#f8f9fa',
                            color: activeTab === section.id ? 'white' : 'black'
                        }}
                    >
                        {section.name}
                    </p>
                ))}
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                {activeTab === 'registered-scholars' && (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',

                            padding: '20px'
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: '#fff',
                                padding: '30px',
                                borderRadius: '16px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                maxWidth: '500px',
                                width: '100%',
                                textAlign: 'center'
                            }}
                        >
                            <h2 style={{ color: '#343a40', marginBottom: '10px' }}>
                                पञ्जीकृत शोध छात्र सूची
                            </h2>

                            <a
                                href={pdfFile}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'inline-block',
                                    padding: '12px 24px',
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    textDecoration: 'none',
                                    borderRadius: '8px',
                                    fontWeight: '500',
                                    transition: 'background-color 0.3s ease'
                                }}
                                onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
                                onMouseOut={(e) => (e.target.style.backgroundColor = '#007bff')}
                            >
                                📄 PDF खोलें / डाउनलोड करें
                            </a>
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
}
